/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCollectionMobile = {
  init: function($section) {
  
  	let mobileLayout = window.matchMedia('(max-width: 798px)');
  
  	if(mobileLayout.matches){
      
    console.log("JS COLLECTION MOBILE!");

    // Add settings from schema to current object
    //window.PXUTheme.jsCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    // function to check if browser is IE
    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

    // Ensure product media libraries are present
    if (!isIE11) {
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
        }
      ],)
    }
  
  	/* TOGGLE PANEL */
    const filterButton = document.querySelector(".toggle-filters-button");
        
    const closeFilterButton = document.querySelector(".close-filters-button");

    const sidebarSection = document.querySelector(".sidebar-section");
  
  	const overlay = document.querySelector('.ajax-cart__overlay');
  
	function showFilterPanel(){
          
		sidebarSection.classList.add('is-visible');
          
		overlay.classList.add('is-visible');
	}
        
	function hideFilterPanel(){
          
		sidebarSection.classList.remove('is-visible');
          
		overlay.classList.remove('is-visible');
	}
  
  	overlay.addEventListener('click', function(){
  	
    	hideFilterPanel();
  	});

    filterButton.addEventListener('click', showFilterPanel);
        
    closeFilterButton.addEventListener('click', hideFilterPanel);
  
  	/* END OF TOGGLE PANEL */
  
	/*async function renderSection() {
    var appendToBody = await fetch(`/?sections=collection__main`)
    .then(response => response.json()) // It returns a promise which resolves with the result of parsing the body text as JSON.
    .then(data => { 
      console.log(data);
      //$('body').append( data["collection__main"] ); // Append the contents to the body with JQuery
      
      function htmlToElement(html) {
        var template = document.createElement('template');
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        return template.content.firstChild;
      }
      
      const newCollectionMain = htmlToElement(data['collection__main']);
      
      console.log(newCollectionMain);
      
      const collectionMain = document.querySelector('.collection-main');
      
      console.log(collectionMain);
      
      //collectionMain.parentNode.replaceChild(newCollectionMain, collectionMain);

    });
  	}*/
  
  	//renderSection();
  
    const collectionMain = document.querySelector('.collection-main-section');

    const collectionHandle = collectionMain.dataset.collectionHandle;

    const filterForm = document.querySelector('[data-faceted-filter-form]');

    const filterBlocks = filterForm.querySelectorAll('.block__faceted-filtering');

    /*filterBlocks.forEach((block,index) => {

      if(index < 2){

        const header = block.querySelector('.sidebar-block__heading');

        const content = block.querySelector('.sidebar-block__content');

        //const headerButton = block.querySelector('[data-has-toggle-option]');

        console.log("INDEX",headerButton);

        headerButton.click();

        //eventFire(headerButton, 'click');

        //sidebar-block__content
      }
    });*/

    /*const addClickToClearButton = function(button){

      filterGroup.querySelectorAll('input[type=checkbox]:checked').forEach(checkbox => {
          checkbox.checked = false;
      });
    };*/
  
    async function fetchResults(filterString = "") {
      var appendToBody = await fetch(`/collections/` + collectionHandle + '?view=json&' + filterString)
      .then(response => response.json())
      .then(data => { 
        //console.log("RESULTS:", data);
        const unavailableFilters = data.unavailable_filters;

        document.querySelectorAll('.faceted-filter-group-display__list-item-input').forEach(filter => {
          filter.disabled = false;
        });

        unavailableFilters.forEach(filter => {
          //console.log("FILTERS: ",filter.name, filter.value);

          const filterInput = document.querySelector('[name="' + filter.name + '"][value="' + filter.value + '"]');

          if(filterInput){
              filterInput.checked = false;
              filterInput.disabled = true;
          }
        });
      });
    };
  
    const updateFilters = function(){
      let filterString = "";

      const filterBlocks = filterForm.querySelectorAll('input[type=checkbox]:checked');

      filterForm.querySelectorAll('input[type=checkbox]:checked').forEach(checkbox => {
        filterString = filterString + checkbox.name + "=" + checkbox.value.replace(" ", "+") + "&";
      });

      //console.log(filterString);

      fetchResults(filterString);
    };
  
  	//const clearButtonString = '<a class="faceted-filter-group-display__header-clear"><span class="icon clear-filter" data-icon="x" style="margin-right:4px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="x"><polygon points="97.83 7.83 92.17 2.17 50 44.34 7.83 2.17 2.17 7.83 44.34 50 2.17 92.17 7.83 97.83 50 55.66 92.17 97.83 97.83 92.17 55.66 50 97.83 7.83"></polygon></g></svg></span><span>Clear</span></a>';
  
  	const clearButtonInnerString = '<span class="icon clear-filter" data-icon="x" style="margin-right:4px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="x"><polygon points="97.83 7.83 92.17 2.17 50 44.34 7.83 2.17 2.17 7.83 44.34 50 2.17 92.17 7.83 97.83 50 55.66 92.17 97.83 97.83 92.17 55.66 50 97.83 7.83"></polygon></g></svg></span><span>Clear</span>';
  
  	const updateClearButtons = function(){
    
	filterBlocks.forEach(block => {
      
      const active = block.querySelectorAll('input[type=checkbox]:checked');
      
      const clearButton = block.querySelector('.faceted-filter-group-display__header-clear');
      
      if(active.length == 0){
        
        if(clearButton){ clearButton.remove(); }
      }
      
      else {
        
        if(!clearButton){
          
          //let newClearButton = document.createRange().createContextualFragment(clearButtonString);
          //let newClearButton = new DOMParser().parseFromString(clearButtonString, 'text/html').documentElement;
          
          const newClearButton = document.createElement("a");
          
          newClearButton.classList.add('faceted-filter-group-display__header-clear');
          
          newClearButton.innerHTML = clearButtonInnerString;
          
          newClearButton.addEventListener('click', function(event){
            //console.log("CLICK");
            event.preventDefault();
            
          	this.remove();
            
            const checked = block.querySelectorAll('input[type=checkbox]:checked');
            
            //for(const mutation of mutationsList) {
            
            checked.forEach(checkbox => {
                checkbox.checked = false;
            });
            
            updateFilters();
          });

          block.querySelector('.faceted-filter-group-display__header').append(newClearButton);
        }
      }
    });
  };

  	//fetchResults();
  
    filterForm.addEventListener('change', e => {
      if (e.target.type == 'number') return;

      updateClearButtons();

      updateFilters();
    });
  
  	const clearFiltersButtons = document.querySelectorAll('.faceted-filter-group-display__header-clear');
        
	//console.log(clearFiltersButtons);

	clearFiltersButtons.forEach(filter => {
          
		//console.log(filter);

		filter.addEventListener('click', event => {
			event.preventDefault();
            
            //console.log(event.currentTarget);
            
            const clearLink = event.currentTarget;
            
            const filterGroup = clearLink.parentElement.parentElement.parentElement.parentElement;
            
            //const filterGroupTitle = filterGroup.dataset.filterGroup;
            
            //console.log("FILTER GROUP:", filterGroupTitle);

            event.currentTarget.parentElement.innerHTML = "";

            filterGroup.querySelectorAll('input[type=checkbox]:checked').forEach(checkbox => {
              checkbox.checked = false;
            });
            
            updateFilters();
            
            //const removeFilterButtons = document.querySelectorAll(".faceted-active-filters__remove-filter[data-filter-group=" + CSS.escape(filterGroupTitle) + "]");
            
            //removeFilterButtons.forEach(filterButton => { filterButton.remove(); });
		});
	});
    }
  }
}

/******/ })()
;